import { gqlCountryEnum as countryType } from '@minecraft.graphql-types';
import { getEnvironment } from '@minecraft.environment';
import { appConfig as globalAppConfig } from '@minecraft.app-config';

const env = getEnvironment();
const appConfig: any = {};

appConfig.companyName = 'Casting Networks';
appConfig.cdnRoot = env.CDN_URL;
appConfig.svgRoot = `${appConfig.cdnRoot}/images/icons/b21/`;
appConfig.amzCdnRoot = `${appConfig.cdnRoot}`;
appConfig.defaultCountryCode = countryType.US;
appConfig.countryAllKey = globalAppConfig.allCountriesCode;
appConfig.defaultLanguageCode = 'en';
appConfig.defaultMeasurementUnit = 'imperial'; // vs metric
appConfig.initialPage = 1;
appConfig.pageLimit = 25;
appConfig.defaultResultSizeOptions = [25, 50, 100, 250, 500];
appConfig.faqLink = 'https://support.castingnetworks.com/hc/en-us/categories/360004519651-Onboarding';
appConfig.appName = 'Onboarding';

export default appConfig;
